/** Auth callbacks stay on this app, including nested desktop approval URLs. */
export function safeAuthRedirect(value: unknown): string {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u001f]/.test(value)) return '/workspace';
  try {
    const parsed = new URL(value, 'https://auth.genie.invalid');
    return parsed.origin === 'https://auth.genie.invalid' ? `${parsed.pathname}${parsed.search}${parsed.hash}` : '/workspace';
  } catch { return '/workspace'; }
}

/** Auth pages and the hosted workspace are different apps on the same origin. */
export function completeAuthRedirect(value: unknown): void {
  window.location.assign(safeAuthRedirect(value));
}
